import { KsService } from '@siclop/kstone-vue'

export class ActivityTypeService extends KsService {
  protected static mainUrl = '/activity-types'
}
